const formattedNumberWithComma = (number: number | string) => {
  if (number === null || number === undefined) return '';
  const numberString = typeof number === 'string' ? number : number.toString();
  const parts = numberString.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.length > 1 ? `${parts[0]}.${parts[1]}` : parts[0];
};

export default formattedNumberWithComma;
